export const sharableTypes = Object.freeze({
  POST: 'post',
  COMMENT: 'comment',
});
